import React from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';

import EmployerSectionPlaceholder from '../../EmployerSectionPlaceholder';
interface Props {
  isLoading?: boolean;
  isHSA?: boolean;
}
const EmployerClaimSpendPreloader: React.FC<Props> = ({ isHSA, isLoading }) => {
  if (isLoading) {
    if (isHSA) {
      return (
        <Box
          pad="spacing24"
          background="canvas"
          round="container2Round"
          height="256px"
          border={{ size: '1px', color: 'border2' }}
          data-testid="employer-claim-spend_loading-hsa"
        >
          <Text size="medium" weight={700} data-testid="employer-claim-spend_title">
            Balance
          </Text>
          <Box direction="row" height="100%" margin={{ top: 'spacing12' }}>
            <Box width="190px">
              <ShimmerBox round="checkboxRound" height="44px" width="100%" margin={{ top: 'spacing24' }} />
            </Box>
            <Box fill direction="row" align="end" height="100%" margin={{ left: 'spacing32' }}>
              <ShimmerBox round="checkboxRound" height="176px" width="100%" />
            </Box>
          </Box>
        </Box>
      );
    }
    return (
      <Box
        pad="spacing24"
        background="canvas"
        round="container2Round"
        height="256px"
        border={{ size: '1px', color: 'border2' }}
        data-testid="employer-claim-spend_loading"
      >
        <Text size="medium" weight={700} data-testid="employer-claim-spend_title">
          Claim spend
        </Text>
        <Box direction="row" height="100%" margin={{ top: 'spacing12' }}>
          <Box width="190px">
            <ShimmerBox round="checkboxRound" height="44px" width="100%" margin={{ top: 'spacing24' }} />
          </Box>
          <Box fill direction="row" align="end" height="100%" margin={{ left: 'spacing32' }}>
            <ShimmerBox round="checkboxRound" height="96px" width="42px" />
            <ShimmerBox round="checkboxRound" height="65px" width="42px" margin={{ left: '17px' }} />
            <ShimmerBox round="checkboxRound" height="74px" width="42px" margin={{ left: '17px' }} />
            <ShimmerBox round="checkboxRound" height="64px" width="42px" margin={{ left: '17px' }} />
            <ShimmerBox round="checkboxRound" height="69px" width="42px" margin={{ left: '17px' }} />
          </Box>
        </Box>
      </Box>
    );
  }
  if (isHSA) {
    return <EmployerSectionPlaceholder />;
  }
  return <EmployerSectionPlaceholder> We couldn't load your Claim spend</EmployerSectionPlaceholder>;
};
export default EmployerClaimSpendPreloader;
